import { useState } from "react";
import Asas1DCSidebar from "./Asas1DCSidebar/Asas1DCSidebar";
import Asas1DCTabsContent from "./Asas1DCTabsContent/Asas1DCTabsContent";
import MFDRoom from "./TabsComponents/MFDRoom";
import RPPModal from "../RPPModal/RPPModal";
import { ModalContext } from "hooks/ModalProvider";
import { useContext } from "react";

function Asas1DC() {
  const [selectedTab, setSelectedTab] = useState('mdfRoom');
  const { rppModalShown, setRppModalShown } = useContext(ModalContext);

  const tabs = [
    {
      id: 'mdfRoom',
      label: 'MDF Room',
      content: <MFDRoom />
    },
    {
      id: 'room1',
      label: 'Room 1',
      content: null
    },
    {
      id: 'room2',
      label: 'Room 2',
      content: null
    },

  ];

  return (
    <>
      <div className="grid grid-cols-12 p-2 gap-4  h-full">
        <div className="col-span-3">
          <Asas1DCSidebar tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        </div>
        <div className="col-span-9 ">
          <Asas1DCTabsContent tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        </div>
      </div>
      {rppModalShown && <RPPModal setShowModal={() => setRppModalShown(false)} />}
    </>
  );
}
export default Asas1DC;